import React from "react";
import { Link } from "react-router-dom";
import { Footer } from "@/components/landing/Footer";
import { WaveIcon } from "@/components/landing/Decorations";

export default function TermsPage() {
    return (
        <div className="min-h-screen bg-cream-100 text-ink">
            <header className="border-b border-cream-300 bg-white/80 backdrop-blur">
                <div className="mx-auto max-w-[1080px] px-5 sm:px-8 py-4 flex items-center justify-between">
                    <Link to="/" className="flex items-center gap-2.5">
                        <WaveIcon color="#FF5B3E" className="w-6 h-4"/>
                        <span className="font-display text-[22px] font-semibold tracking-tight">Audo</span>
                    </Link>
                    <Link to="/" className="text-[13px] text-ink-muted hover:text-coral transition-colors">Back to home</Link>
                </div>
            </header>

            <main className="mx-auto max-w-[900px] px-5 sm:px-8 py-10 sm:py-14">
                <p className="text-[11px] uppercase tracking-[0.2em] font-semibold text-coral mb-2">Legal</p>
                <h1 className="font-display text-[40px] sm:text-[52px] leading-[1.05] font-semibold tracking-tight mb-4">Terms of Service</h1>
                <p className="text-[14px] text-ink-muted mb-8">Last updated: April 27, 2026</p>

                <div className="bg-white border border-cream-300 rounded-3xl p-6 sm:p-8 space-y-6 text-[14px] leading-relaxed">
                    <section>
                        <h2 className="font-semibold text-[18px] mb-2">1. Agreement</h2>
                        <p>By using Audo, you agree to these terms and our Privacy Policy. If you do not agree, please do not use the service.</p>
                    </section>
                    <section>
                        <h2 className="font-semibold text-[18px] mb-2">2. Service scope</h2>
                        <p>Audo provides Bengali text-to-audio generation, hosting, embedding tools, analytics, and account management features.</p>
                    </section>
                    <section>
                        <h2 className="font-semibold text-[18px] mb-2">3. Account responsibilities</h2>
                        <p>You are responsible for account security, lawful content usage, and all activity under your account credentials.</p>
                    </section>
                    <section>
                        <h2 className="font-semibold text-[18px] mb-2">4. Billing and plans</h2>
                        <p>Paid plans and top-ups are billed as shown at checkout. Character limits and feature availability depend on your active plan and policy updates.</p>
                    </section>
                    <section>
                        <h2 className="font-semibold text-[18px] mb-2">5. Acceptable use</h2>
                        <p>You may not use Audo for unlawful, abusive, infringing, or harmful content. We may suspend accounts that violate these rules.</p>
                    </section>
                    <section>
                        <h2 className="font-semibold text-[18px] mb-2">6. Availability and updates</h2>
                        <p>We may modify, improve, or temporarily pause parts of the service to maintain quality and security.</p>
                    </section>
                    <section>
                        <h2 className="font-semibold text-[18px] mb-2">7. Contact</h2>
                        <p>For legal or account questions, contact <a href="mailto:contact@audo.dev" className="text-coral hover:underline">contact@audo.dev</a>.</p>
                    </section>
                </div>
            </main>

            <Footer/>
        </div>
    );
}
